/* @ngInject */
function RepositoryFiltersController ($scope, $translate) {
  $scope.fileFilters = [
    { icon: 'image', name: 'image', checked: false },
    { icon: 'play', name: 'video', checked: false },
    { icon: 'headphones', name: 'audio', checked: false },
    { icon: 'file-text', name: 'document', checked: false },
    { icon: 'pen-tool', name: 'design', checked: false }
  ]

  $scope.extensionOptions = []

  const extensions = {
    default: [
      { value: 'all', label: $translate.instant('repository.all'), active: true }
    ],
    image: [
      { value: 'png', label: 'PNG' },
      { value: 'jpg', label: 'JPG' },
      { value: 'jpeg', label: 'JPEG' },
      { value: 'webp', label: 'Webp' },
      { value: 'tif', label: 'Tif' },
      { value: 'tiff', label: 'Tiff' },
      { value: 'bmp', label: 'BMP' }
    ],
    video: [
      { value: 'mp4', label: 'MP4' },
      { value: 'mov', label: 'MOV' },
      { value: 'avi', label: 'AVI' },
      { value: 'mpeg', label: 'MPEG' },
      { value: 'mkv', label: 'MKV' },
      { value: 'rmvb', label: 'RMVB' }
    ],
    audio: [
      { value: 'mp3', label: 'MP3' },
      { value: 'wav', label: 'WAV' },
      { value: 'wma', label: 'WMA' },
      { value: 'aac', label: 'AAC' },
      { value: 'ac3', label: 'AC3' }
    ],
    document: [
      { value: 'deskfy', label: 'DESKFY' },
      { value: 'doc', label: 'DOC' },
      { value: 'docx', label: 'DOCX' },
      { value: 'txt', label: 'TXT' },
      { value: 'odt', label: 'ODT' },
      { value: 'csv', label: 'CSV' },
      { value: 'xls', label: 'XLS' },
      { value: 'xlsx', label: 'XLSX' },
      { value: 'ods', label: 'ODS' },
      { value: 'ppt', label: 'PPT' },
      { value: 'pdf', label: 'PDF' },
      { value: 'zip', label: 'ZIP' }
    ],
    design: [
      { value: 'svg', label: 'SVG' },
      { value: 'ai', label: 'AI' },
      { value: 'psd', label: 'PSD' },
      { value: 'eps', label: 'EPS' },
      { value: 'crd', label: 'CRD' },
      { value: 'ttf', label: 'TTF' },
      { value: 'otf', label: 'OTF' }
    ]
  }

  extensions.all = [
    ...extensions.image,
    ...extensions.video,
    ...extensions.audio,
    ...extensions.document,
    ...extensions.design
  ]

  const api = {
    _setExtensionOptions,
    _updateFilterButton
  }

  this.getApi = () => api

  function activate () {
    api._setExtensionOptions()
  }

  activate()

  $scope.onFilterChange = (filter) => {
    $scope.filterParams[filter] = !$scope.filterParams[filter]

    for (const key in $scope.filterParams) {
      if (key !== filter) {
        $scope.filterParams[key] = false
        api._updateFilterButton(key)
      }
    }

    api._setExtensionOptions()
  }

  $scope.onSelectChange = (event) => {
    const value = event.detail.value
    $scope.$emit('repository-filters.extension-filter-update', value)
  }

  function _setExtensionOptions () {
    if ($scope.filterParams.image) {
      $scope.extensionOptions = [...extensions.default, ...extensions.image]
    } else if ($scope.filterParams.video) {
      $scope.extensionOptions = [...extensions.default, ...extensions.video]
    } else if ($scope.filterParams.audio) {
      $scope.extensionOptions = [...extensions.default, ...extensions.audio]
    } else if ($scope.filterParams.document) {
      $scope.extensionOptions = [...extensions.default, ...extensions.document]
    } else if ($scope.filterParams.design) {
      $scope.extensionOptions = [...extensions.default, ...extensions.design]
    } else {
      $scope.extensionOptions = [...extensions.default, ...extensions.all]
    }
  }

  function _updateFilterButton (filter) {
    $(`.repository-filters .file-filters uds-filter-button-quick[name='${filter}']`).attr('checked', false)
  }
}

export { RepositoryFiltersController }
